import * as React from 'react';
import {
  calculateProgress,
  PrimaryActionButtonProps,
  primaryActionButtonProps,
} from './utils';
import * as registrationMachine from '../machines/accountRegistration';
import lang from '../lang';
import {UseMachineType} from '../machines/useAccountRegistrationMachineType';

type Props = {
  registrationMachine: UseMachineType;
};

type ScreenProps = Props & {
  lang: typeof lang.registerUsername;
  onFormSubmit: React.ComponentProps<'form'>['onSubmit'];
  progress: number;
  actionButtons: {
    primary: PrimaryActionButtonProps;
  };
  usernameInputProps: {
    value: string | null;
    onChange: (value: string) => unknown;
    error: string | undefined;
  };
  firstName: string | null;
};

export type RegisterUsernameScreenType = React.ComponentType<ScreenProps>;

export function RegisterUsername(
  props: Props & {children: RegisterUsernameScreenType}
) {
  const [
    {
      context: {
        account,
        validationErrors,
        navigator: {location},
      },
      matches,
    },
    send,
  ] = props.registrationMachine;

  const progress = calculateProgress({
    draftAccount: account,
    location,
  });

  const actionButtons = {
    primary: primaryActionButtonProps({
      children: lang.registerUsername.buttons.primary.title,
      loading: matches({
        [registrationMachine.RegistrationState.username]:
          registrationMachine.RegistrationState.submittingUsername,
      }),
      disabled: Boolean(
        !account.username || validationErrors?.account?.username
      ),
    }),
  };

  const renderProps: ScreenProps = {
    ...props,
    lang: lang.registerUsername,
    onFormSubmit: e => {
      e.preventDefault();
      send({
        type: registrationMachine.RegistrationEvent.UPDATE_REGISTRATION,
        payload: {username: account.username},
      });
    },
    progress,
    actionButtons,
    usernameInputProps: {
      value: account.username,
      onChange: username => {
        send({
          type: registrationMachine.RegistrationEvent.UPDATE_DATA,
          // @ts-ignore
          payload: {account: {username}},
        });
      },
      error: validationErrors?.account?.username,
    },
    firstName: account.firstname,
  };

  const Screen = props.children;
  return <Screen {...renderProps} />;
}
